<template>
  <span v-if="showViewDetails()">
    <i
      class="el-icon-search icon-action"
      id="btn-layout-detail-dialog"
      @click="handleOpenDialog"
      size="mini"
      icon="el-icon-plus"
    ></i>
    <el-dialog
      id="layout-detail-dialog"
      :close-on-click-modal="false"
      :title="$t('layout.viewDetailsTitle')"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
    >
      <el-row :gutter="10">
        <el-col :span="5" class="list-name">
          <label class="margin-bottom-small-list">{{ $t('layout.date') }}</label>
        </el-col>
        <el-col :span="7">
          <span class="span-small-list">{{ layoutDate | moment("MM/DD/YYYY") }}</span>
        </el-col>
        <el-col :span="5">
          <label class="margin-bottom-small-list">{{ $t('layout.layoutTemplate') }}</label>
        </el-col>
        <el-col :span="7">
          <span class="span-small-list">{{ dayOfWeek.concat(' - ').concat(code).concat(' - ').concat(name) }}</span>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :md="24" :lg="12">
          <storage-location
            :layoutTemplateId="layoutTemplateId"
            :layoutType="layoutTypeLayout"
            :layoutTemplateName="layoutTemplateName"
            @loadStoragePosition="handleLoadStoragePosition"
            @cleanStorageLocation="cleanSelectedStorageLocation"
            ref="storage-locations" />
        </el-col>

        <el-col :md="24" :lg="12">
          <storage-position
            :layoutTemplateId="layoutTemplateId"
            :storageLocationId="selectedStorageLocation.storageLocationId"
            :storageLocationCode="selectedStorageLocation.storageLocation"
            :area="selectedStorageLocation.area"
            :shipperGroupName="selectedStorageLocation.shipperGroupName"
            :layoutType="layoutTypeLayout"
            :layoutTemplateName="layoutTemplateName"
          />
        </el-col>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import moment from 'moment';
import constants from '@/utils/constants';
import StorageLocation from './StorageLocation';
import StoragePosition from './StoragePosition';

export default {
  name: 'ViewDetails',
  components: {
    StorageLocation,
    StoragePosition
  },
  props: {
    layoutTemplateId: {
      type: Number,
      required: true
    },
    dayOfWeek: {
      type: String,
      default: ''
    },
    code: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    layoutDate: {
      type: String,
      default: ''
    }
  },
  computed: {
    layoutTypeLayout() {
      return constants.LAYOUT_TEMPLATE.LAYOUT_TYPES.LAYOUT;
    },
    layoutTemplateName() {
      return moment(this.layoutDate).format(constants.DATES.DEFAULT_DISPLAY_FORMAT)
        .concat(' ')
        .concat(this.dayOfWeek)
        .concat(' - ')
        .concat(this.code)
        .concat(' - ')
        .concat(this.name);
    },
  },
  data() {
    return {
      dialogVisible: false,
      selectedStorageLocation: {
        layoutTemplateId: 0,
        storageLocationId: 0,
        storageLocation: '',
        area: '',
        shipperGroupName: '',
        positionsAssigned: ''
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs['storage-locations'].handleSearch();
      });
    },
    showViewDetails() {
      return this.$can(this.permissions.WAREHOUSE.VIEW_LAYOUTS);
    },
    handleLoadStoragePosition(storageLocation) {
      this.selectedStorageLocation = storageLocation;
    },
    handleClose(done) {
      this.cleanSelectedStorageLocation();
      this.$store.dispatch('layout/search', {});
      done();
    },
    cleanSelectedStorageLocation() {
      this.selectedStorageLocation = {
        layoutTemplateId: 0,
        storageLocationId: 0,
        storageLocation: '',
        area: '',
        shipperGroupName: '',
        positionsAssigned: ''
      };
    }
  }
};
</script>
